import React from "react";
import { withRouter } from "react-router-dom";

import AWSHelp from "components/AWSHelp/AWSHelp";

class AWSHelpContainer extends React.PureComponent {
  render() {
    return <AWSHelp {...this.props} />;
  }
}

export default withRouter(AWSHelpContainer);
